// extracted by mini-css-extract-plugin
export default {"share":"ShareButton-module__share","icon":"ShareButton-module__icon"};